import * as React from "react";

import { RouteComponentProps } from "react-router";
import { Link, NavLink } from "react-router-dom";
import { Card, CardBody, CardFooter, Col, Container, Row } from "reactstrap";
import LoginForm from "./loginForm";


interface BAN {
    ban: string;
    bills: Bill[];
}

interface Bill {

    cdt: string,
    pdfurl: string,
    rqstyp: string | undefined,
    dev: string | undefined,
    systran: string

}

interface accountState {
    bans: BAN[];
    isLoading: boolean;
}
export class login extends React.Component<any> {
    public state: accountState = {
        bans: [],
        isLoading: false,
    };

    constructor(props: Readonly<any>) {
        super(props);
    }
    // This method is called when the component is first added to the document
    public componentDidMount() {
        this.ensureDataFetched();
    }

    private ensureDataFetched() {

    }
    public render() {
        return (
            <Container>
                <Row>
                    <Col />
                    <Col lg="8">
                        <Container>
                            <h3>
                                Frontier CABS Bill Portal
                            </h3>
                            <hr />
                            <Card>
                                <CardBody>
                                    <LoginForm />

                                </CardBody>
                            </Card>
                        </Container>
                    </Col>
                    <Col />
                </Row>
            </Container >
        );
    }
}
